import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "contentStyles", "orientation"];
import { AbstractDeviceFrame, StyledDefaultContentWrapper, StyledDefaultInnerWrapper, StyledDefaultOuterWrapper } from './AbstractDeviceFrame';
import { AbstractDeviceTemplate } from './AbstractDeviceTemplate';
import styled, { useTheme } from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTabletFrame = styled.svg.withConfig({
  displayName: "DeviceFrameTablet__StyledTabletFrame",
  componentId: "sc-12o6lyr-0"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
const TabletPortraitFrame = props => {
  const theme = useTheme();
  const fillColor = theme.color['fill-surface-raised'];
  const strokeColor = theme.color['border-core-default'];
  return /*#__PURE__*/_jsx(StyledTabletFrame, Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "rotate(90 194 195)",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("path", {
        fill: fillColor,
        stroke: strokeColor,
        d: "M-.5 15.994C-.5 6.884 6.886-.5 16.004-.5h484.992c9.112 0 16.504 7.391 16.504 16.494v356.012c0 9.11-7.386 16.494-16.504 16.494H16.004C6.892 388.5-.5 381.109-.5 372.006V15.994zm25 2.001v352.01a5.502 5.502 0 0 0 5.495 5.495h469.01a5.5 5.5 0 0 0 5.495-5.495V17.995a5.502 5.502 0 0 0-5.495-5.495H29.995a5.5 5.5 0 0 0-5.495 5.495z"
      }), /*#__PURE__*/_jsx("circle", {
        fill: strokeColor,
        cx: "12",
        cy: "194",
        r: "4"
      })]
    })
  }));
};
const TabletLandscapeFrame = props => {
  const theme = useTheme();
  const fillColor = theme.color['fill-surface-raised'];
  const strokeColor = theme.color['border-core-default'];
  return /*#__PURE__*/_jsx(StyledTabletFrame, Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(1 1)",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("path", {
        fill: fillColor,
        stroke: strokeColor,
        d: "M-.5 15.994C-.5 6.884 6.886-.5 16.004-.5h484.992c9.112 0 16.504 7.391 16.504 16.494v356.012c0 9.11-7.386 16.494-16.504 16.494H16.004C6.892 388.5-.5 381.109-.5 372.006V15.994zm25 2.001v352.01a5.502 5.502 0 0 0 5.495 5.495h469.01a5.5 5.5 0 0 0 5.495-5.495V17.995a5.502 5.502 0 0 0-5.495-5.495H29.995a5.5 5.5 0 0 0-5.495 5.495z"
      }), /*#__PURE__*/_jsx("circle", {
        fill: strokeColor,
        cx: "12",
        cy: "194",
        r: "4"
      })]
    })
  }));
};
const TABLET_DEVICE_SPECS = {
  tabletPortrait: {
    Template: TabletPortraitFrame,
    top: 25.5,
    right: 13.5,
    bottom: 13.5,
    left: 13.5,
    height: 519,
    width: 390
  },
  tabletLandscape: {
    Template: TabletLandscapeFrame,
    top: 13.5,
    right: 13.5,
    bottom: 13.5,
    left: 25.5,
    height: 390,
    width: 519
  }
};
const TabletTemplate = ({
  dimensions,
  Template,
  children
}) => {
  return /*#__PURE__*/_jsx(AbstractDeviceTemplate, {
    dimensions: dimensions,
    Template: Template,
    children: children
  });
};
const TabletInnerWrapper = ({
  dimensions,
  children
}) => {
  return /*#__PURE__*/_jsx(StyledDefaultInnerWrapper, {
    $dimensions: dimensions,
    children: children
  });
};
const TabletOuterWrapper = ({
  containerCSSStyles,
  children
}) => {
  return /*#__PURE__*/_jsx(StyledDefaultOuterWrapper, {
    $cssStyles: Object.assign({}, containerCSSStyles),
    children: children
  });
};
const TabletContentWrapper = ({
  contentCSSStyles,
  children
}) => {
  return /*#__PURE__*/_jsx(StyledDefaultContentWrapper, {
    $cssStyles: Object.assign({}, contentCSSStyles),
    children: children
  });
};
export const DeviceFrameTablet = _ref => {
  let {
      children,
      contentStyles = {},
      orientation = 'portrait'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps: containerStyleProps
  } = filterProps(rest);
  const containerCSSStyles = useMapTokenPropsToCSS(containerStyleProps);
  const {
    tokenProps: contentStyleProps
  } = filterProps(contentStyles);
  const contentCSSStyles = useMapTokenPropsToCSS(contentStyleProps);
  const computedSpecs = orientation === 'landscape' ? TABLET_DEVICE_SPECS.tabletLandscape : TABLET_DEVICE_SPECS.tabletPortrait;
  return /*#__PURE__*/_jsx(AbstractDeviceFrame, {
    OuterWrapper: TabletOuterWrapper,
    containerCSSStyles: containerCSSStyles,
    contentCSSStyles: contentCSSStyles,
    ContentWrapper: TabletContentWrapper,
    InnerWrapper: TabletInnerWrapper,
    spec: computedSpecs,
    Template: TabletTemplate,
    "data-test-id": domProps['data-test-id'],
    children: children
  });
};